/** Character codes and character classes the grammar extensions share (CommonMark 2.1, as Lezer reads them). */

/** `\t` */
export const TAB = 9;
/** ` ` */
export const SPACE = 32;
/** `-`: scene breaks, the centered close */
export const DASH = 45;
/** `<`: the centered close */
export const LESS_THAN = 60;
/** `\`: escapes */
export const BACKSLASH = 92;
/** `^`: small caps */
export const CARET = 94;
/** `*`: scene breaks */
export const STAR = 42;
/** `_`: scene breaks */
export const UNDERSCORE = 95;

/** Whitespace as Lezer's block parsers count it: space, tab, line feed, carriage return. */
export function isSpace(code: number): boolean {
  return code === SPACE || code === TAB || code === 10 || code === 13;
}

/**
 * Whether `index` in `text` is preceded by an odd number of backslashes, so the character there is escaped.
 * Reading before the start gives NaN, which ends the count.
 */
export function isEscaped(text: string, index: number): boolean {
  let backslashes = 0;
  for (let i = index - 1; text.charCodeAt(i) === BACKSLASH; i -= 1) backslashes += 1;
  return backslashes % 2 === 1;
}
